import { create } from "zustand";

export interface Brand {
	id: number;
	name: string;
	createdAt?: string;
	updatedAt?: string;
	email?: string;
}

interface SystemBrandStore {
	systemBrandToDelete: Brand | undefined;
	systemBrandToEdit: Brand | undefined;
	isDeleteModalOpen: boolean;
	isEditModalOpen: boolean;
	setSystemBrandToDelete: (brand: Brand | undefined) => void;
	setSystemBrandToEdit: (brand: Brand | undefined) => void;
	setIsDeleteModalOpen: (isOpen: boolean) => void;
	setIsEditModalOpen: (isOpen: boolean) => void;
}

export const useSystemBrandStore = create<SystemBrandStore>((set) => ({
	systemBrandToDelete: undefined,
	systemBrandToEdit: undefined,
	isDeleteModalOpen: false,
	isEditModalOpen: false,
	setSystemBrandToDelete: (brand) => set({ systemBrandToDelete: brand }),
	setSystemBrandToEdit: (brand) => set({ systemBrandToEdit: brand }),
	setIsDeleteModalOpen: (isOpen) => set({ isDeleteModalOpen: isOpen }),
	setIsEditModalOpen: (isOpen) => set({ isEditModalOpen: isOpen })
}));
